import { Header4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CommercialInfoReadyBusiness.css';
import { ICommercialInfoReadyBusinessProps } from './types';
import { CommercialIncome } from '../../../../CommercialIncome';

export const CommercialInfoReadyBusiness: React.FC<ICommercialInfoReadyBusinessProps> = props => {
  const {
    title,
    commercialInfo: { monthlyIncome },
  } = props;

  return (
    <div className={styles['container']}>
      <Header4>{title}</Header4>
      {monthlyIncome?.currency != null && !!monthlyIncome.income && (
        <CommercialIncome currency={monthlyIncome.currency} income={monthlyIncome.income} incomePeriod="мес." />
      )}
    </div>
  );
};

CommercialInfoReadyBusiness.displayName = 'CommercialInfoReadyBusiness';
